import {
  ERROR_INFO_BY_PERSONAL_NUM,
  GET_INFO_BY_PERSONAL_NUM,
  GET_INFO_BY_PERSONAL_NUM_AGENT,
  LOADING_INFO_BY_PERSONAL_NUM,
  SET_INTERESTED_USER_DATA,
  SIGN_STRING_ERROR,
  STATUS_INFO_BY_PERSONAL_NUM,
} from "../types";

import {
  CREATE_BILL_REQUEST,
  CREATE_BILL_SUCCESS,
  CREATE_BILL_FAILURE,
  FETCH_QR_REQUEST,
  FETCH_QR_SUCCESS,
  FETCH_QR_FAILURE,
  SAVE_APPLICATION_FAILURE,
  SAVE_APPLICATION_SUCCESS,
  SAVE_APPLICATION_REQUEST,
  DEREGISTER_ENGINE_REQUEST,
  DEREGISTER_ENGINE_SUCCESS,
  DEREGISTER_ENGINE_FAILURE,
  DEREGISTER_RESET_STATUS_ERROR,
  GET_DATA_BU_UNP_REQUEST,
  GET_DATA_BU_UNP_SUCCESS,
  GET_DATA_BU_UNP_FAILURE,
  CHECK_ENGINE_VIN_REQUEST,
  CHECK_ENGINE_VIN_SUCCESS,
  CHECK_ENGINE_VIN_FAILURE,
  CHECK_ENGINE_VIN_OK,
  CHECK_ENGINE_STATIC_VIN_REQUEST,
  CHECK_ENGINE_STATIC_VIN_OK,
  CHECK_ENGINE_STATIC_VIN_SUCCESS,
  CHECK_ENGINE_STATIC_VIN_FAILURE,
  sendSignString,
} from "./actionsRegistrationChangesInformationRHF";

const initialState = {
  userByPersonalNumStatus: "idle",
  userByPersonalNumError: null,
  userByPersonalNum: {},
  agentByPersonalNum: {
    agentCountry: "Республика Беларусь",
  },
  sendSignStringError: null,
  interestedUser: {},

  serviceBill: null,
  loading: false,
  error: null,

  registrationIsLoading: false,
  appName: null,
  registrationResult: null,

  deregisterEngineLoading: false,
  deregisterEngineError: "",
  deregisterEngineData: null,

  dataByUnpLoading: false,
  dataByUnpError: "",
  dataByUnp: {},

  checkEngineVinLoading: false,
  checkEngineVinError: "",

  checkEngineStaticVinLoading: false,
  checkEngineStaticVinError: "",
};

const registrationChangesInformationRHFReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_INTERESTED_USER_DATA:
      return {
        ...state,
        interestedUser: action.payload,
      };
    case GET_INFO_BY_PERSONAL_NUM:
      return {
        ...state,
        userByPersonalNumStatus: "success",
        userByPersonalNum: action.payload,
      };
    case GET_INFO_BY_PERSONAL_NUM_AGENT:
      return {
        ...state,
        userByPersonalNumStatus: "success",
        agentByPersonalNum: action.payload,
      };
    case STATUS_INFO_BY_PERSONAL_NUM:
      return {
        ...state,
        userByPersonalNumStatus: "idle",
        userByPersonalNumError: null,
      };
    case LOADING_INFO_BY_PERSONAL_NUM:
      return {
        ...state,
        userByPersonalNumStatus: "loading",
        userByPersonalNumError: null,
      };
    case ERROR_INFO_BY_PERSONAL_NUM:
      return {
        ...state,
        userByPersonalNumStatus: "error",
        userByPersonalNumError: action.payload,
      };
    case SIGN_STRING_ERROR:
      return {
        ...state,
        sendSignStringError: action.payload,
      };
    // case CREATE_BILL_REQUEST:
    case FETCH_QR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_BILL_SUCCESS:
      return {
        ...state,
        serviceBill: action.payload,
        loading: false,
      };
    case FETCH_QR_SUCCESS:
      return {
        ...state,
        serviceBill: {
          ...state.serviceBill,
          ...action.payload,
          QRurl: action.payload.QRurl,
        },
        loading: false,
      };
    case CREATE_BILL_FAILURE:
    case FETCH_QR_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SAVE_APPLICATION_REQUEST:
      return {
        ...state,
        registrationIsLoading: true,
        registrationResult: null,
      };
    case SAVE_APPLICATION_SUCCESS:
      return {
        ...state,
        registrationIsLoading: false,
        appName: action.payload,
        registrationResult: "success",
      };
    case SAVE_APPLICATION_FAILURE:
      return {
        ...state,
        registrationIsLoading: false,
        registrationResult: "error",
      };
    case DEREGISTER_ENGINE_REQUEST:
      return {
        ...state,
        deregisterEngineLoading: true,
        deregisterEngineError: null,
      };
    case DEREGISTER_ENGINE_SUCCESS:
      return {
        ...state,
        deregisterEngineLoading: false,
        deregisterEngineData: action.payload,
        deregisterEngineError: "success",
      };
    case DEREGISTER_ENGINE_FAILURE:
      return {
        ...state,
        deregisterEngineLoading: false,
        deregisterEngineError: "error",
      };
    case DEREGISTER_RESET_STATUS_ERROR: {
      return {
        ...state,
        registrationResult: null,
        deregisterEngineError: null,
      };
    }
    case GET_DATA_BU_UNP_REQUEST:
      return {
        ...state,
        dataByUnpLoading: true,
        dataByUnp: {},
        dataByUnpError: null,
      };
    case GET_DATA_BU_UNP_SUCCESS:
      return {
        ...state,
        dataByUnpLoading: false,
        dataByUnp: action.payload,
        dataByUnpError: "success",
      };
    case GET_DATA_BU_UNP_FAILURE:
      return {
        ...state,
        dataByUnpLoading: false,
        dataByUnpError: "error",
      };
    case CHECK_ENGINE_VIN_REQUEST:
      return {
        ...state,
        checkEngineVinLoading: true,
        checkEngineVinError: null,
      };
    case CHECK_ENGINE_VIN_OK:
      return {
        ...state,
        checkEngineVinLoading: false,
        checkEngineVinError: null,
      };
    case CHECK_ENGINE_VIN_SUCCESS:
      return {
        ...state,
        checkEngineVinLoading: false,
        checkEngineVinError: action.payload,
      };
    case CHECK_ENGINE_VIN_FAILURE:
      return {
        ...state,
        checkEngineVinLoading: false,
        checkEngineVinError: "Ошибка отправки данных",
      };
    case CHECK_ENGINE_STATIC_VIN_REQUEST:
      return {
        ...state,
        checkEngineStaticVinLoading: true,
        checkEngineStaticVinError: null,
      };
    case CHECK_ENGINE_STATIC_VIN_OK:
      return {
        ...state,
        checkEngineStaticVinLoading: false,
        checkEngineStaticVinError: null,
      };
    case CHECK_ENGINE_STATIC_VIN_SUCCESS:
      return {
        ...state,
        checkEngineStaticVinLoading: false,
        checkEngineStaticVinError: action.payload,
      };
    case CHECK_ENGINE_STATIC_VIN_FAILURE:
      return {
        ...state,
        checkEngineStaticVinLoading: false,
        checkEngineStaticVinError: "Ошибка отправки данных",
      };

    default:
      return state;
  }
};

export default registrationChangesInformationRHFReducer;
